import { cx } from "@/utils";

import styles from "../Base.module.css";

interface TextareaProps extends React.HTMLProps<HTMLTextAreaElement> {
  block?: boolean;
  error?: boolean;
}

const Textarea: React.FunctionComponent<TextareaProps> = ({
  error = false,
  className,
  block,
  disabled,
  ...props
}) => {
  return (
    <span className={cx(styles.textarea, { [styles.block]: block }, className)}>
      <textarea
        disabled={disabled}
        aria-invalid={error}
        aria-disabled={disabled}
        className={styles.root}
        {...props}
      />
    </span>
  );
};

export default Textarea;
